import React from 'react'

const separator = ({ isEditing, isDragging, item }) => (
	<div style={{ paddingTop: 10, paddingBottom: 10 }}>
		<hr className="reach_separator" />
	</div>
)

export default separator
